import { __decorate, __metadata } from "tslib";
import { v4 as uuidv4 } from "uuid";
import { Type } from "class-transformer";
import { AssetPropertyModel } from "./assetProperty";
let AssetEditModel = /** @class */ (() => {
    class AssetEditModel {
        constructor() {
            this.id = uuidv4();
            this.assetTypeId = "";
            this.assetType = "";
            this.name = "";
            this.assetCode = "";
            this.assetCategoryName = "";
            this.dateOfPurchase = "";
            this.price = null;
            this.employeeName = "";
            this.teamName = "";
            this.statusId = "";
            this.vendorId = "";
            this.invoiceNumber = "";
            this.serialNumber = "";
            this.make = "";
            this.modelNumber = "";
            this.warrantyPeriod = 0;
            this.scrappedOnAsString = "";
            this.disposedOnAsString = "";
            this.dateOfPurchaseAsString = "";
            this.warrantyStartDateAsString = "";
            this.warrantyEndDateAsString = "";
            this.repairStatus = false;
            this.sentToRepairOnAsString = "";
            this.returnedFromRepairOnAsString = "";
            this.assetLocationId = null;
            this.assetLocationName = "";
        }
    }
    __decorate([
        Type(() => AssetPropertyModel),
        __metadata("design:type", Array)
    ], AssetEditModel.prototype, "assetProperties", void 0);
    return AssetEditModel;
})();
export { AssetEditModel };
export default class AssetEdit extends AssetEditModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
